import {OrganizationTokenActions, OrganizationTokenActionTypes} from '../actions/organization-token.actions';
import {TokenWithId} from '../models/token';
import {ErrorPayload} from '../models/general';

export interface State {
  entities: { [id: string]: string };
  isGetOrganizationTokenLoading: boolean;
  isGetOrganizationTokenLoaded: boolean;
  getOrganizationTokenError: string | null;
}

export const initialState: State = {
  entities: {},
  isGetOrganizationTokenLoading: false,
  isGetOrganizationTokenLoaded: false,
  getOrganizationTokenError: null
};

export function reducer(state = initialState, action: OrganizationTokenActions): State {
  switch (action.type) {

    case OrganizationTokenActionTypes.GetOrganizationToken:
    case OrganizationTokenActionTypes.GetOrganizationTokens: {
      return {
        ...state,
        isGetOrganizationTokenLoading: true,
        isGetOrganizationTokenLoaded: false,
        getOrganizationTokenError: null
      }
    }

    case OrganizationTokenActionTypes.GetOrganizationTokenComplete: {
      // Upsert when loaded
      const tokenWithId: TokenWithId = action.payload;
      const entities = {...state.entities, [tokenWithId.id]: tokenWithId.token};

      return {
        ...state,
        entities,
        isGetOrganizationTokenLoading: false,
        isGetOrganizationTokenLoaded: true
      }
    }

    case OrganizationTokenActionTypes.GetOrganizationTokensComplete: {
      // Upsert when loaded
      const _organizationTokenEntities: { [id: string]: string } = action.payload;
      const entities = Object.keys(_organizationTokenEntities).reduce((acc: { [id: string]: string }, id: string) => {
        return {
          ...acc,
          [id]: _organizationTokenEntities[id]
        };
      }, {...state.entities});

      return {
        ...state,
        entities,
        isGetOrganizationTokenLoading: false,
        isGetOrganizationTokenLoaded: true
      }
    }

    case OrganizationTokenActionTypes.GetOrganizationTokenError:
    case OrganizationTokenActionTypes.GetOrganizationTokensError: {
      const errorPayload: ErrorPayload = action.payload;
      return {
        ...state,
        isGetOrganizationTokenLoading: false,
        isGetOrganizationTokenLoaded: true,
        getOrganizationTokenError: errorPayload.errorMessage
      }
    }

    default:
      return state;
  }
}

export const organizationTokenEntities = (state: State) => state.entities;
export const isGetOrganizationTokenLoading = (state: State) => state.isGetOrganizationTokenLoading;
export const isGetOrganizationTokenLoaded = (state: State) => state.isGetOrganizationTokenLoaded;
export const getOrganizationTokenError = (state: State) => state.getOrganizationTokenError;
